import { render, staticRenderFns } from "./child_focal_monitor.vue?vue&type=template&id=0a513d80&"
import script from "./child_focal_monitor.vue?vue&type=script&lang=js&"
export * from "./child_focal_monitor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\1603014\\develop\\qplus\\qpeplus\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('0a513d80', component.options)
    } else {
      api.reload('0a513d80', component.options)
    }
    module.hot.accept("./child_focal_monitor.vue?vue&type=template&id=0a513d80&", function () {
      api.rerender('0a513d80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/monitor/tra/child_focal_monitor.vue"
export default component.exports